import axios from '../plugins/axios'
import sitesInfo from "@/js/helper/sites-info";

export default {
  orderRequest(orderRequestInfo){
    const url = sitesInfo.wwwHiworks + `/goods/application/order`
    // const data = JSON.stringify(orderRequestInfo)

    return axios.post(url, orderRequestInfo, {
      headers: {
        'content-type': 'text/json'
      }
    })
  },


  checkDomain(domain) {
    return new Promise((resolve => {
      const url = sitesInfo.wwwHiworks + `/office/domain_chk_v3?domain=` + domain
      axios.get(url, {
        withCredentials: true
      })
        .then((apiResponse)=>{
          let result = apiResponse.data

          if (parseInt(result.whois_result) === -1) {
            resolve({
                flag : 'impossible',
                is_possible: false,
                msg : '등록할 수 없는 도메인입니다.'
              })
          }
          else if(result.service_result){
            resolve({
                flag : 'hosting',
                is_possible: false,
                msg : '메일 호스팅을 사용하고 있는 도메인이기 때문에 신청할 수 없습니다. 확인 후 다시 신청하시기 바랍니다.'
              })
          }
          else if(result.subdomain_use_flag) {
            resolve({
                flag : 'sub_domain',
                is_possible: false,
                msg : '부도메인을 사용중인 도메인입니다.'
              })
          }
          else if (parseInt(result.whois_result) === 1){
            if(result.is_gabia_domain){
              resolve({
                flag : 'GABIA_OWNER',
                is_possible: true,
                msg : '도메인 사용이 가능합니다.'
              })
            }
            else{
              resolve({
                flag : 'NO_GABIA_OWNER',
                is_possible: true,
                msg : '도메인 사용이 가능합니다.'
              })
            }

          }
          else {
            resolve({
                flag : 'no_register',
                is_possible: false,
                msg : '미 등록된 도메인입니다. '
            })
          }
        })
      
      
    }))
  }
}